<template>
  <div>
    <span class="col-xs-12 first-char" v-if="firstCharOld !== gallery.firstChar">{{ gallery.firstChar }}</span>
    <div class="card--link--container col-xs-12 col-md-4 col-sm-6">
      <a class="zoom" :href="gallery.profileLink" target="_blank" :title="gallery.name">
        <div class="card">
          <div class="img-container"
               :class="[gallery.galleryThumbnailIsWider === 0 ? 'height' : 'width',
                    gallery.galleryThumbnailHeight == gallery.galleryThumbnailWidth ? 'quadrat' : '' ]"
               v-if="gallery.galleryThumbnail">
            <img :src="'data:image/jpeg;base64,'+gallery.galleryThumbnail" class="card-img-top"
                 :alt="[gallery.name, gallery.galleryThumbnailAlternativeText]">
          </div>
          <div v-else class="img"><span>{{ gallery.name }} </span></div>
          <div class="card-body">

            <div class="card-text-container">
              <h2 class="card-title"> {{ gallery.name }} </h2>
              <p class="card-text"> {{ gallery.city }}, {{ gallery.country }} </p>
            </div>
            <div class="categorys">
              <div v-for="(category, j) in gallery.categories" :key="j">
                <span :class="category"></span>
                <span v-if="category.includes('art22.07')" class="category category--red"></span>
                <span v-else-if="category.includes('art22.08')" class="category category--yellow"></span>
              </div>
            </div>

          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'GalleryList',
  props: ["gallery", "firstCharOld"],
  data() {
    return {
      firstChar: this.gallery.firstChar
    }
  },
  created() {
  },
  methods: {}
}
</script>